import { render } from "./LearningBoxCollapse.vue?vue&type=template&id=15d251a6"
import script from "./LearningBoxCollapse.vue?vue&type=script&lang=js"
export * from "./LearningBoxCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__